import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const LocationRow = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) 112px',
  gap: 12,
  alignItems: 'start',
});

export const LocationHint = styled('p')({
  margin: '6px 0 0',
  fontSize: '0.8rem',
  lineHeight: 1.45,
  color: '#5a6478',
});
